import ConstituentSearchFilterField from '@/constants/ConstituentSearchFilterField';

// Any LOADING ones are to be added
const FieldLabelMap: Record<ConstituentSearchFilterField, string> = {
  [ConstituentSearchFilterField.NAME_EMAIL_PHONE]:
    'FORMS_NAME_EMAIL_PHONE_LABEL',
  [ConstituentSearchFilterField.USER_IDS]: 'ASSIGNEE',
  [ConstituentSearchFilterField.HAS_ASSIGNEES]: 'ASSIGNEE',
  [ConstituentSearchFilterField.CONSTITUENT_CATEGORIES]: 'CATEGORIES',
  [ConstituentSearchFilterField.CONSTITUENT_RULES]: 'DONOR_CATEGORIES',
  [ConstituentSearchFilterField.CITY]: 'FORMS_CITY_LABEL',
  [ConstituentSearchFilterField.STATE]: 'FORMS_STATE_LABEL',
  [ConstituentSearchFilterField.POSTAL_CODE]: 'FORMS_POSTAL_CODE_LABEL',
  [ConstituentSearchFilterField.COUNTRY]: 'FORMS_COUNTRY_LABEL',
  [ConstituentSearchFilterField.CONSTITUENT_LABEL_IDS]:
    'FORMS_CONSTITUENT_LABELS',
  [ConstituentSearchFilterField.DONATION_LABEL_IDS]:
    'FORMS_CONTRIBUTION_LABELS',
  [ConstituentSearchFilterField.DONATION_TYPES]: 'CONTRIBUTION_TYPE_LABEL',
  [ConstituentSearchFilterField.DONATION_DATE]: 'CONTRIBUTION_DATE',
  [ConstituentSearchFilterField.DONATION_DATE_TYPE]: 'FORMS_TIME_PERIOD_LABEL',
  [ConstituentSearchFilterField.DONATION_LIFETIME_TOTAL_AMOUNT]:
    'DONOR_CONTRIBUTIONS_LIFETIME',
  [ConstituentSearchFilterField.DONATION_LIFETIME_TOTAL_TIME]:
    'DONOR_CONTRIBUTIONS_LIFETIME_TIME',
  [ConstituentSearchFilterField.DONATION_THIS_YEAR_TOTAL_AMOUNT]:
    'DONOR_CONTRIBUTION_CY',
  [ConstituentSearchFilterField.DONATION_THIS_YEAR_TOTAL_TIME]:
    'DONOR_CONTRIBUTIONS_CY_TIME',
  [ConstituentSearchFilterField.DONATION_LAST_YEAR_TOTAL_AMOUNT]:
    'DONOR_CONTRIBUTIONS_LY',
  [ConstituentSearchFilterField.DONATION_LAST_YEAR_TOTAL_TIME]:
    'DONOR_CONTRIBUTIONS_LY_TIME',
  [ConstituentSearchFilterField.DONATION_MADE]: 'CONTRIBUTION_MADE',
  [ConstituentSearchFilterField.DONATION_PLAN_CADENCE]:
    'RECURRING_CADENCE_CRITERIA_LABEL',
  [ConstituentSearchFilterField.DONATION_AMOUNT]: 'CONTRIBUTION_TOTAL_AMOUNT',
  [ConstituentSearchFilterField.DONATION_MINUTES]: 'CONTRIBUTION_TOTAL_TIME',
  [ConstituentSearchFilterField.IN_HONOR]: 'DEDICATION_IN_HONOR_MEMORY',
  [ConstituentSearchFilterField.IS_DECEASED]: 'IS_DECEASED_LABEL',
  [ConstituentSearchFilterField.CAMPAIGN_IDS]: 'CAMPAIGNS',
  [ConstituentSearchFilterField.BIRTHDAY_MONTH]: 'FORMS_BIRTHDATE_MONTH_LABEL',
  [ConstituentSearchFilterField.DOB]: 'BIRTHDAY_LABEL',
  [ConstituentSearchFilterField.BOARD_IDS]: 'LIFECYCLE_BOARD',
  [ConstituentSearchFilterField.COLUMN_IDS]: 'LIFECYCLE_BOARD_COLUMN',
  [ConstituentSearchFilterField.CONNECTION_EMPLOYER_CONSTITUENT_IDS]:
    'CONNECTIONS_EMPLOYER_LABEL',
  [ConstituentSearchFilterField.CONNECTION_HOUSEHOLD_CONSTITUENT_IDS]:
    'CONNECTIONS_HOUSEHOLD_LABEL',
  [ConstituentSearchFilterField.CONNECTION_CONSTITUENT_IDS]:
    'CONNECTIONS_ANY_LABEL',
  [ConstituentSearchFilterField.CONSTITUENT_TYPE]: 'CONSTITUENT_TYPE',
  [ConstituentSearchFilterField.IWAVE_AFFINITY_SCORE]:
    'IWAVE_FILTER_AFFINITY_LABEL',
  [ConstituentSearchFilterField.IWAVE_CAPACITY_SCORE]:
    'IWAVE_FILTER_CAPACITY_LABEL',
  [ConstituentSearchFilterField.IWAVE_PLANNED_GIVING_SCORE]:
    'IWAVE_FILTER_PLANNED_GIVING',
  [ConstituentSearchFilterField.IWAVE_PROPENSITY_SCORE]:
    'IWAVE_FILTER_PROPENSITY_LABEL',
  [ConstituentSearchFilterField.IWAVE_SCORE]: 'IWAVE_FILTER_IWAVE_LABEL',
};

export default FieldLabelMap;
